import { useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import { SeoHelper } from "../../components/helpers/SeoHelper";
import { Link } from "react-router-dom";

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export default function AuthorSongsIndex() {

    useEffect(() => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'view_song_list', {
                content_type: 'author_index',
                source: 'browse'
            });
        }
    }, []);

    return (
        <>
            <SeoHelper
                uri="/authors"
                title="Worship Songs by Author"
                description="Browse over 5,000 worship song authors alphabetically by surname. Find songs by specific composers to help plan meaningful church services."
            />

            <section className="section section-lg">

                <Container>

                    <Row className="justify-content-center">

                        <Col lg="8">

                            <h1 className="display-3 text-center text-primary">
                                Worship Songs by Author
                            </h1>

                            <p className="lead text-center text-muted mb-5">
                                Browse over 5,000 worship song authors alphabetically by surname.
                            </p>

                            <h2 className="h4 text-center mb-4">
                                Browse by Surname
                            </h2>

                            <div className="d-flex flex-wrap justify-content-center mb-5" style={{ gap: '8px' }}>
                                {LETTERS.map(letter => (
                                    <Link
                                        key={letter}
                                        to={`/authors/${letter.toLowerCase()}`}
                                        className="btn btn-outline-primary"
                                        style={{ width: '48px', fontWeight: 600 }}
                                    >
                                        {letter}
                                    </Link>
                                ))}
                            </div>

                            <p className="text-muted text-center mt-4">
                                Many worship leaders plan services around songs from specific
                                authors or songwriting traditions. These pages help you discover
                                worship songs by each songwriter in our library.
                            </p>

                        </Col>

                    </Row>

                </Container>

            </section>
        </>
    );
}
